import type { IAlertProps } from "@components/molecules/alert/types";

/**
 * Default properties for an alert.
 * @type {IAlertProps}
 */
export const ALERT_DEFAULT_PROPS: IAlertProps = {
  type: "information",
  open: false,
  title: "",
};
